import * as React from "react";
import { forwardRef } from "react";
const SvgLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 15L4 7.78788L12 1", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgLeft);
export default ForwardRef;
